/**
 * Landing -> idle as ONE movement (2026-10-12, PO: the high pays "play the
 * animation twice").
 *
 * Every symbol's `in` used to end at rest, and its idle rose straight out of
 * it — a bump and a glow, then a bump and a glow again. The reel symbol rigs
 * now end their `in` on the idle's pose at its peak, and carry an event
 * `land_idle_join` (float = that idle time, hand-added in the JSON — see the
 * animator list). Queued after `in` here, the idle starts AT that time: the
 * landing hands straight into the idle's falling half, then it loops as ever.
 *
 * A rig without the event (an older export) queues its idle from 0, as before.
 */

export const LAND_IDLE_JOIN_EVENT = "land_idle_join";

/**
 * Queue `idleName` (looped) on track 0 after the landing already on it.
 * @param {import("@esotericsoftware/spine-pixi-v7").Spine} spine
 * @param {string} idleName
 * @returns {object|null} the idle's TrackEntry
 */
export const queueIdleAfterLanding = (spine, idleName) => {
  const state = spine?.state;
  if (!state || !idleName) return null;
  const entry = state.addAnimation(0, idleName, true, 0);
  const join = spine.skeleton?.data?.findEvent(LAND_IDLE_JOIN_EVENT)?.floatValue;
  // Added to when the entry starts (AnimationState keeps a preset trackTime).
  if (entry && join > 0) entry.trackTime = join;
  return entry;
};
